import React from 'react';
import _ from 'lodash';
import { appContext } from '../../util/decorators';
import ContentMeta from '../ContentMeta.jsx';
import FeedText from './FeedText.jsx';
import FeedContainerText from './FeedContainerText';
import Thumbnail from '../Thumbnail.jsx';
import ArticleLink from '../ArticleLink.jsx';
import FeedPicture from './FeedPicture.jsx';

@appContext
export default class FeedContainerBig extends React.PureComponent {
  render() {
  	
    const { contentContainer, country, showExtraBanner, hideIngress, showCompetitionName, topNews} = this.props;
    if (!contentContainer) return null;
    const competition = _.get(contentContainer, `tags.competitions[0].${country}.name`);

    return (
        <div className="feed-container feed-container-big">
        
          <div className="top-news no-margin-bottom col-md-12" style={{padding: 0}}>
         
            <FeedContainerText contentContainers={topNews} limit={3} />
          </div>
          
          {
            showExtraBanner &&
              <div className="banner">
                <h2>{this.context.app.t('FeedContainerBig.extra')}</h2>
              </div>
          }
          <Thumbnail className="thumbnail-big" data={contentContainer} maxItems={2}>
            <ArticleLink contentContainer={contentContainer}>
              <FeedPicture contentContainer={contentContainer} size={5}/>
            </ArticleLink>
          </Thumbnail>

          <div className="row">
            <div className="col-xs-12">
              <ContentMeta data={contentContainer} noTimestamp />
              <ArticleLink contentContainer={contentContainer}>
                <h4><FeedText contentContainer={contentContainer} type={'FeedThumbnailBig'} /></h4>
              </ArticleLink>
            </div>
          </div>

          <div className="row">
            {
              !hideIngress &&
              <div className="col-md-12">
                <ArticleLink contentContainer={contentContainer}>
                  <p className="preamble">
                    {contentContainer.shortTitle || contentContainer.preamble}
                  </p>
                </ArticleLink>
              </div>
            }
          </div>
        </div>
    );
  }
}

FeedContainerBig.propTypes = {
  contentContainer: React.PropTypes.object.isRequired,
  topNews: React.PropTypes.array,
  country: React.PropTypes.string,
  showExtraBanner: React.PropTypes.bool,
  hideIngress: React.PropTypes.bool,
  showCompetitionsName: React.PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/component/NewsFeed/FeedContainerBig.jsx